export default __webpack_public_path__ + "static/media/googleplay.d50546dc.svg";